var exports = {
  "w": "xe7b6e3d6--fa5de5--header",
  "n": "xe7b6e3d6--fa5de5--controls",
};

module.exports = exports;
